var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x9A\xB6\xE5\xB1\x9E\xE5\x85\xB3\xE7\xB3\xBB 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 15.6833C3 12.5088 5.4653 9.93545 8.50642 9.93545C11.2322 9.93545 13.4954 12.0028 13.9354 14.7174L15.8331 14.7174L15.8331 10.4073C15.8331 8.29659 17.4529 6.58151 19.4635 6.5474L19.5245 6.5469L20.2077 6.54683C20.6841 4.51095 22.4431 3 24.5403 3C27.0033 3 29 5.08424 29 7.6553C29 10.2264 27.0033 12.3106 24.5403 12.3106C22.3337 12.3106 20.5013 10.6378 20.1437 8.44068L19.5245 8.44068C18.4963 8.44068 17.6609 9.30366 17.6443 10.3748L17.644 10.4073L17.644 20.896C17.644 21.9713 18.4692 22.845 19.4934 22.8624L19.5245 22.8626L20.3113 22.8626C20.9043 21.0182 22.5736 19.6894 24.5403 19.6894C27.0033 19.6894 29 21.7736 29 24.3447C29 26.9158 27.0033 29 24.5403 29C22.2101 29 20.2974 27.1346 20.0977 24.7564L19.5245 24.7564C17.5062 24.7564 15.8662 23.0624 15.8336 20.9598L15.8331 20.896L15.8331 16.6175L13.9405 16.6175C13.5177 19.3173 11.293 21.3848 8.59743 21.4304L8.50642 21.4312C5.4653 21.4312 3 18.8578 3 15.6833Z",
    fill: "#006AB2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/隶属关系.290993b26914ca0871541b78cf1b8f11.svg";
export { ForwardRef as ReactComponent };